require('slick-carousel');

function qaSlider() {
    $('.__slider').slick({
        adaptiveHeight: true,
        slidesToShow: 1,
        dots: true,
        arrows: false,
        autoplay: true,
        duration: 3200,
    });
}

qaSlider();


